export enum AuthenticationType {
    SkyKickAuth = 0,
    M365Auth = 1
}
